import styled, { css } from 'styled-components';

import { Typography } from '@/components/Typography';

export const TaxText = styled(Typography)<{ disabled?: boolean }>`
  min-width: 47px;

  ${({ disabled = false, theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${disabled
      ? theme.colors.secondaryGreyAlpha48
      : theme.colors.secondaryGrey};
    padding-botttom: ${theme.spacing(1)};
  `};
`;
